import './scss/sellops-upsell.scss';

import './page/sellops-analytics';
import './page/sellops-settings';
import './page/sellops-rules';

const { Module } = Shopware;

Module.register('sellops-upsell', {
    type: 'plugin',
    name: 'sellops-upsell',
    title: 'sellops.general.mainMenuLabel',
    description: 'sellops.general.description',
    version: '1.0.0',
    color: '#5C67F2',
    icon: 'regular-chart-line-arrow',

    routes: {
        analytics: {
            component: 'sellops-analytics',
            path: 'analytics',
        },
        rules: {
            component: 'sellops-rules',
            path: 'rules',
        },
        settings: {
            component: 'sellops-settings',
            path: 'settings',
        },
    },

    navigation: [
        {
            id: 'sellops-upsell-root',
            label: 'sellops.general.mainMenuLabel',
            color: '#5C67F2',
            icon: 'regular-chart-line-arrow',
            path: 'sellops.upsell.analytics',
            parent: 'sw-marketing',
            position: 100,
        },
        {
            id: 'sellops-upsell-analytics',
            label: 'sellops.general.analyticsMenuLabel',
            color: '#5C67F2',
            icon: 'regular-chart-line-arrow',
            path: 'sellops.upsell.analytics',
            parent: 'sellops-upsell-root',
        },
        {
            id: 'sellops-upsell-rules',
            label: 'sellops.general.rulesMenuLabel',
            color: '#5C67F2',
            icon: 'regular-rule',
            path: 'sellops.upsell.rules',
            parent: 'sellops-upsell-root',
        },
        {
            id: 'sellops-upsell-settings',
            label: 'sellops.general.settingsMenuLabel',
            color: '#5C67F2',
            icon: 'regular-cog',
            path: 'sellops.upsell.settings',
            parent: 'sellops-upsell-root',
        },
    ],
});
